var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalcard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 10.5H15C11.685 10.5 9 13.17 9 16.455V31.545C9 34.83 11.685 37.5 15 37.5H33C36.315 37.5 39 34.83 39 31.545V16.455C39 13.17 36.315 10.5 33 10.5Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 19.125H27C26.385 19.125 25.875 18.615 25.875 18C25.875 17.385 26.385 16.875 27 16.875H34.5C35.115 16.875 35.625 17.385 35.625 18C35.625 18.615 35.115 19.125 34.5 19.125Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 25.125H28.5C27.885 25.125 27.375 24.615 27.375 24C27.375 23.385 27.885 22.875 28.5 22.875H34.5C35.115 22.875 35.625 23.385 35.625 24C35.625 24.615 35.115 25.125 34.5 25.125Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 31.125H31.5C30.885 31.125 30.375 30.615 30.375 30C30.375 29.385 30.885 28.875 31.5 28.875H34.5C35.115 28.875 35.625 29.385 35.625 30C35.625 30.615 35.115 31.125 34.5 31.125Z",
    fill: "#111827"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7502 23.6859C20.6638 23.6859 22.2152 22.1345 22.2152 20.2209C22.2152 18.3072 20.6638 16.7559 18.7502 16.7559C16.8365 16.7559 15.2852 18.3072 15.2852 20.2209C15.2852 22.1345 16.8365 23.6859 18.7502 23.6859Z",
    fill: "#111827"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9498 25.6656C19.1548 25.5906 18.3298 25.5906 17.5348 25.6656C15.0148 25.9056 12.9898 27.9006 12.7498 30.4206C12.7348 30.6306 12.7948 30.8406 12.9448 30.9906C13.0948 31.1406 13.2898 31.2456 13.4998 31.2456H23.9998C24.2098 31.2456 24.4198 31.1556 24.5548 31.0056C24.6898 30.8556 24.7648 30.6456 24.7498 30.4356C24.4948 27.9006 22.4848 25.9056 19.9498 25.6656Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalcard);
export default __webpack_public_path__ + "static/media/personalcard.027a56a347ee7bcc50a2a77f153e1551.svg";
export { ForwardRef as ReactComponent };